
import React from 'react';
import { Table } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import FilterSection from '@/components/football/FilterSection';

interface LeagueTableCardProps {
  selectedCountry: string | null;
  selectedLeague: string | null;
  selectedYear: string | null;
  onCountrySelect: (country: string) => void;
  onLeagueSelect: (league: string) => void;
  onYearSelect: (year: string) => void;
  availableLeagues: string[];
  availableYears: string[];
}

export const LeagueTableCard: React.FC<LeagueTableCardProps> = ({
  selectedCountry,
  selectedLeague,
  selectedYear,
  onCountrySelect,
  onLeagueSelect,
  onYearSelect,
  availableLeagues,
  availableYears,
}) => {
  return (
    <Card className="hover:shadow-lg transition-shadow w-full h-full">
      <CardHeader className="text-center">
        <Table className="w-24 h-24 mx-auto mb-4" />
        <CardTitle className="text-2xl">League Tables</CardTitle>
        <CardDescription className="text-lg">
          View season statistics and league standings
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col">
        <FilterSection 
          selectedCountry={selectedCountry} 
          selectedLeague={selectedLeague} 
          selectedYear={selectedYear} 
          onCountrySelect={onCountrySelect} 
          onLeagueSelect={onLeagueSelect} 
          onYearSelect={onYearSelect} 
          leagues={availableLeagues} 
          years={availableYears} 
        />
      </CardContent>
    </Card>
  );
};

export default LeagueTableCard;
